export default [

     {
          path: '/nationality',
          name: 'Nationality',
          component: () => import("@/views/Page/Nationality/Nationality.vue"),
          meta: {
               title: 'Nationalities',
          },
     }
];